/**
 * Redux Configuration
 */
/* tslint:disable:no-string-literal */

import * as PreferencesActions from './actions/preferences';
import rootReducer from './reducers';
import rootSaga from './sagas';

import { Actions as FarceActions, BrowserProtocol, createHistoryEnhancer, queryMiddleware } from 'farce';
import * as found from 'found';
import { applyMiddleware, compose, createStore, Store } from 'redux';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';

import { fbqMiddleware } from '../analytics/fbq';
import { gtmMiddleware } from '../analytics/gtm';
import { transitionHookCreator } from '../router/transitionHook';

export interface EnhancedStore<S> extends Store<S> {
  farce: {
    addTransitionHook: (location: any) => boolean | string | null | Promise<boolean | string | null>;
  };
}

const anyFound = found as any;

export const configureStore = (routeConfig): EnhancedStore<IStoreState> => {
  const saga = createSagaMiddleware();
  const store = createStore(
    rootReducer,
    window['__REDUX_DEVTOOLS_EXTENSION__'] && window['__REDUX_DEVTOOLS_EXTENSION__'](
      process.env.NODE_ENV !== 'development' ? {
        actionsBlacklist: [
          'Authentication',
          'LocalStorage',
          'Player/UPDATE_CURRENT_TRACK_ELAPSED_TIME',
        ],
        stateSanitizer: ({
          authentication,
          postAuthenticationRequests,
          staticData,
          user,
          user: {
            stripeToken,
            ...stateUserState
          },
          ...safeState
        }: IStoreState) => ({
          ...safeState,
          user: stateUserState,
        }),
      } : {}),
    compose(
      applyMiddleware(thunk, saga, gtmMiddleware, fbqMiddleware),
      createHistoryEnhancer({
        protocol: new BrowserProtocol(),
        middlewares: [queryMiddleware],
      }),
      anyFound.createMatchEnhancer(new anyFound.Matcher(routeConfig)),
    ),
  ) as EnhancedStore<IStoreState>;

  saga.run(rootSaga);
  store.dispatch(FarceActions.init());
  store.dispatch(PreferencesActions.requestSetPreferencesFromLocalStorage());
  store.farce.addTransitionHook(transitionHookCreator(store));

  // if (module.hot) {
  //   module.hot.accept('./reducers', () => {
  //     const nextRootReducer = require('./reducers').default;
  //     store.replaceReducer(nextRootReducer);
  //   });
  // }

  return store;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/index.ts